import { useState, useEffect } from 'react';
import { apiClient } from '../api/client';

interface AuthorizationResponse {
  authorized: boolean;
}

/**
 * Hook that checks whether the current user is authorized to access
 * Legacy Ball settings (admin section).
 *
 * Calls GET /legacy-ball/authorization on mount and returns the result.
 * Defaults to isAuthorized: false on any network or server error (fail-closed).
 */
export function useLegacyBallAuthorization(): {
  isAuthorized: boolean;
  isLoading: boolean;
} {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function checkAuthorization() {
      try {
        const data = await apiClient<AuthorizationResponse>(
          '/legacy-ball/authorization',
        );
        if (!cancelled) {
          setIsAuthorized(data.authorized);
        }
      } catch {
        // Fail-closed: default to unauthorized on any error
        if (!cancelled) {
          setIsAuthorized(false);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    }

    checkAuthorization();

    return () => {
      cancelled = true;
    };
  }, []);

  return { isAuthorized, isLoading };
}
